/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_DescInputs */

const en_byoa_desc = /** @type {(inputs: Byoa_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save your provider API key, then select it separately for building and planning in each project.`)
};

const id_byoa_desc = /** @type {(inputs: Byoa_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simpan kunci API penyediamu, lalu pilih secara terpisah untuk membangun dan merencanakan di setiap proyek.`)
};

/**
* | output |
* | --- |
* | "Save your provider API key, then select it separately for building and planning in each project." |
*
* @param {Byoa_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_desc = /** @type {((inputs?: Byoa_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_desc(inputs)
	return en_byoa_desc(inputs)
});